import React from 'react';
import LoginForm from 'components/connexion/LoginFom';

const Login = () => {
    return (
		<LoginForm layout="split" hasLabel />
  );
};

export default Login;
